<template>
    <div>
        <div style="display: flex;justify-content: center;">

            <div style="width: 1200px;">
                <Bread :breads="breads" defaultType="2"></Bread>
                <img src="/static/img/zhuhai/关于我们.svg" alt="">

                <div class="about-content-box" >
                    <el-row>
                        <el-col :span="5">
                            <div class="about-type" :class="{active:tabActive=='ZHUHAI_MANAGE'}" @click="changeTab('ZHUHAI_MANAGE')">管理规范</div>
                            <div class="about-type" :class="{active:tabActive=='ZHUHAI_DEPENDENT'}" @click="changeTab('ZHUHAI_DEPENDENT')">依托单位</div>
                            <div class="about-type" :class="{active:tabActive=='ZHUHAI_CONTACT'}" @click="changeTab('ZHUHAI_CONTACT')">联系我们</div>
                        </el-col>
                        <el-col :span="19" style="padding-left: 20px;" >
                            <div style="min-height: 600px;" v-html="content">

                            </div>
                        </el-col>
                    </el-row>

                </div>

            </div>


        </div>
    </div>
</template>

<script setup >
import Platform from './components/Platform'
import Technology from './components/Technology'
import Topic from './components/Topic'
import NewsBox from './components/NewsBox'
import Nav from './components/Nav'
import Banner from './components/Banner'
import {ref, toRefs, reactive, getCurrentInstance, onMounted} from 'vue'
import { Search,RefreshRight } from '@element-plus/icons-vue'
import Bread from "@/components/common/Bread.vue";
import {useRoute} from "vue-router";


const {proxy} = getCurrentInstance();

const breads = ref([
    {text:'首页', name:'ZhuhaiMain', path:'/zhuhai/index'},
    {text:'关于我们', name:'ResRetrieve', path:'/zhuhai/zhuhaiAbout'}
])

const content = ref('');

const tabActive = ref('ZHUHAI_MANAGE');

const changeTab = (id) => {
    tabActive.value = id;
    getContent(id);
}

const getContent = (id) => {

    proxy.$http.post('/core/cms/a/articleContent/info', {id:id}).then(res => {
        if (res.data.state == 0) {
            if(res.data.state === 0){
                content.value = res.data.result.content;
            }
        }
    }).catch(err => {
    });
}



const route = useRoute();
onMounted(()=>{
    getContent('ZHUHAI_MANAGE');
});


</script>

<style lang="less" scoped>


.text-center{
    text-align: center;
}



.about-content-box{
    background: linear-gradient(180deg, #FFFFFF 0%, #F6F9FF 100%);
    background-size: 100% 600px;
    background-repeat: no-repeat;
    padding: 15px 20px;
    border-radius: 10px;
    margin-top: 15px;
}





.scrollbar-demo-item{

    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    margin: 10px;
    text-align: center;
    border-radius: 4px;
    background: var(--el-color-primary-light-9);
    color: var(--el-color-primary);
}
.instrument-title{
    background-color: #007EEC;
    color: white;
    height: 40px;
    font-size: 18px;
    display:flex;
    align-items: flex-end;
    padding: 5px 15px;
}
.about-type{
    margin-top: 10px;
    height: 51px;
    background: linear-gradient(124deg, #F3F9FF 14%, #F4F6FF 55%);
    text-align: center;
    line-height: 51px;
    border-radius: 5px;
}
.about-type.active{
    background: #1B66FC;
    color: white;
}
.platform-info-name{
    font-family: 思源黑体;
    font-size: 18px;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0px;
    color: #1B66FC;
}
.platform-info-field{
    font-family: 思源黑体;
    font-size: 14px;
    font-weight: normal;
    line-height: normal;
    color: rgba(0, 0, 0, 0.85);
    margin-right: 27px;
}
.platform-count{
    font-family: 思源黑体;
    font-size: 20px;
    font-weight: normal;
    line-height: normal;
    letter-spacing: 0px;
}
.platform-info-desc{
    color: #A5A5A5;
    font-family: 思源黑体;
    font-size: 12px;
    font-weight: normal;
    line-height: 14px;
    letter-spacing: 0px;
}
.platform-info-box{
    height: 100px;
    overflow: hidden; /* 1. 隐藏超出内容 */
    text-overflow: ellipsis; /* 2. 超出部分显示省略号 */
    display: -webkit-box; /* 3. 将元素转为弹性伸缩盒子模型 */
    -webkit-line-clamp: 4; /* 4. 关键属性：限制显示的行数，比如2行就写2，3行写3 */
    -webkit-box-orient: vertical; /* 5. 关键属性：设置伸缩盒子的子元素排列方式为垂直 */
}
.about-type:hover{
    cursor: pointer;
}
</style>

